import { ContentBox } from '@/common/layout/ContentBox';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { merge } from 'highcharts';
import { useState } from 'react';
import { ExportButton } from '../buttons/ExportButton';
import { TitleButton } from '../buttons/TitleButton';
import { Form } from '../form/Form';
import { FormFields } from '../form/rendering/FormFields';
import { useNavStateSync } from '../hooks/navState/useNavStateSync';
import { Title } from '../title/Title';
import { DashboardContextProvider } from './DashboardContext';
import { FilterContainer } from './FilterContainer';

export const Dashboard = ({
  title,
  titleIcon,
  entity,
  children,
  fieldDefs,
  defaultFormValues,
  augButtons,
  onReset,
}) => {
  const [formValues, setFormValues] = useNavStateSync('formValues', defaultFormValues);
  const [chartRefs, setChartRefs] = useState();

  const exportReq = () => {
    let chartImages = [];
    chartRefs
      .filter((chart) => chart.current)
      .forEach((chartRef, idx) => {
        let chart = chartRef.current.chart;
        let options = chart.getOptions();
        let exportOptions = options.exporting?.chartOptions || {};
        let finalOptions = merge(options, exportOptions);

        let svg = chart.getSVG(finalOptions);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();

        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          const pngBase64 = canvas.toDataURL('image/png');
          chartImages[idx] = pngBase64;
          return pngBase64;
        };

        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
      });

    return {
      uiType: 'DASHBOARD',
      entity,
      chartImages,
    };
  };

  const resetFilters = () => {
    setFormValues(defaultFormValues);
    if (onReset) {
      onReset();
    }
  };

  const buttons = [
    <TitleButton key="resetViewButton" icon={far.faWindowRestore} toolTip="Reset Filters" onClick={resetFilters} />,
    <ExportButton key="exportButton" exportReq={exportReq} />,
  ];
  if (augButtons) augButtons(buttons);

  return (
    <DashboardContextProvider setChartRefs={setChartRefs}>
      <Form formValues={formValues} setFormValues={setFormValues}>
        <ContentBox>
          {/* Title */}
          <Title icon={titleIcon} title={title} buttons={buttons} />
          {/* Optional Filters from fieldDefs */}
          {fieldDefs && <FormFields fieldDefs={fieldDefs} container={FilterContainer} />}

          {/* Main Dashboard Content */}
          {children}
        </ContentBox>
      </Form>
    </DashboardContextProvider>
  );
};
